import { render, staticRenderFns } from "./Error403View.vue?vue&type=template&id=51e4b5e7&"
import script from "./Error403View.vue?vue&type=script&lang=js&"
export * from "./Error403View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports